
import PageHeader from '@/components/core/PageHeader';
import tableLoading from '@/components/tableLoading';
import NoContent from '@/components/customer-content/NoContent'
import ActivityCard from "@/components/ActivityCard.vue";
export default {
  scrollToTop: true,
 components:{
  PageHeader,
  tableLoading,
  NoContent,
  ActivityCard
 },
 data(){
  return{
    listingLoading: true,
    citySlug: null,
    cityDetails: null,
    activityDetails: null,
  }
 },
 async validate({
      params,
      store
    }) {
      // await operations
      if (params.city != (null || "")) {
        this.citySlug = params.city;
        return true // if the params are valid
      } else {
        return false // will stop Nuxt.js to render the route and display the error page
      }
    },
    created() {
      this.citySlug = this.$route.params.city;
    },
 mounted(){
  this.getCityDetails();
  this.getActivitiesInCity();
 },
 methods:{
  async getCityDetails(){
    this.cityDetails = await fetch(this.$config.fetchUrl + '/api/cities/app/' + this.citySlug).then(res => res
        .text());
      this.cityDetails = this.getCryptKey(this.cityDetails);
  },
  async getActivitiesInCity(){
    this.activityDetails = await fetch(this.$config.fetchUrl + '/api/posts/app/getActivitiesInCity/' + this.citySlug).then(res => res
        .text());
      this.activityDetails = this.getCryptKey(this.activityDetails);
      this.activityDetails.sort((x, y) => Number(y.post.featured) - Number(x.post.featured));
      this.listingLoading =false;
  },
 }
}
